import { render } from "./App.vue?vue&type=template&id=bfe60df2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bfe60df2&lang=scss"

import exportComponent from "E:\\hermes\\hermes-projects\\new-violin-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__